import React from "react";
import { useTranslation } from "react-i18next";

const TableLabels = () => {
  const [_] = useTranslation("global");
  const role = localStorage.getItem("role");

  const roles_labels = {
    employee: [
      _("panel.date"),
      _("panel.code"),
      _("panel.settleName"),
      _("panel.sellersBalance"), 
      _("panel.reportTotal"),
      _("panel.download"),
    ],
    admin: [
      _("panel.date"),
      _("panel.code"),
      _("panel.settleName"),
      _("panel.sellersBalance"),
      _("panel.systemBalance"),
      _("panel.reportTotal"),
      _("panel.download"),
    ],
    fulfillment: [
      _("panel.date"),
      _("panel.code"),
      _("panel.settleName"),
      _("panel.thecharge"),  
      _("panel.download"),
    ],
  };

  return (
    <tr>
      {roles_labels[role].map((label) => {
        return <th>{label}</th>;
      })}
    </tr>
  );
};

export default TableLabels;
